import React from 'react'
import { Grid } from "@mui/material"
import { AppFormSection } from "@components"

import { BACKEND_APIS } from "@constants"
import {
	AlertsBaseDrawer,
	AlertsComparator,
	AlertsComparatorUnit,
	AlertsComparatorValue,
	AlertsComparisonType,
	AlertsConditionName,
	AlertsDrawerBaseFooter,
	AlertsMoreFeatures,
	AlertsProviders,
	AlertsSameInsurance,
	AlertsSites
} from "Pages/ReportsAlerts/Alerts/Conditions/@components"
import MainProvidersRequired from "Pages/ReportsAlerts/Alerts/Conditions/MinMax/Drawer/MainProviders"
import ComparatorDiff from "Pages/ReportsAlerts/Alerts/Conditions/MinMax/Drawer/ComparatorDiff"
import PositionPrice from "Pages/ReportsAlerts/Alerts/Conditions/MinMax/Drawer/PositionPrice"


export default function MinMaxPriceDrawer({ onSubmitAlert, isLoading }) {

	return <AlertsBaseDrawer
		footer={<AlertsDrawerBaseFooter onSubmitAlert={onSubmitAlert} isLoading={isLoading}/>}
		content={<>
			<AppFormSection icon="tag" title="Condition">
				<Grid container spacing={2}>
				<Grid item xs={12} data-tour-id="cond-mm-name">
					<AlertsConditionName/>
				</Grid>
				</Grid>
			</AppFormSection>
			<AppFormSection icon="globe" title="Sites">
				<Grid container spacing={2}>
				<Grid item xs={12} data-tour-id="cond-mm-sites">
					<AlertsSites/>
				</Grid>
				<Grid item xs={12} data-tour-id="cond-mm-main-prov">
					<MainProvidersRequired/>
				</Grid>
				<Grid item xs={3} data-tour-id="cond-mm-position">
					<PositionPrice/>
				</Grid>
				<Grid item xs={3.5} data-tour-id="cond-mm-comparator">
					<AlertsComparator
						urlAjax={`${BACKEND_APIS.MASTER_DATA}/all/options/comparator_min_max`}
					/>
				</Grid>
				<Grid item xs={5.5}/>
				<Grid item xs={3} data-tour-id="cond-mm-comp-diff">
					<ComparatorDiff/>
				</Grid>
				<Grid item xs={3} data-tour-id="cond-mm-comp-value">
					<AlertsComparatorValue/>
				</Grid>
				<Grid item xs={3} data-tour-id="cond-mm-comp-unit">
					<AlertsComparatorUnit/>
				</Grid>
				</Grid>
			</AppFormSection>
			<AppFormSection icon="car" title="Providers">
				<Grid container spacing={2}>
				<Grid item xs={12} data-tour-id="cond-mm-providers">
					<AlertsProviders/>
				</Grid>
				<Grid item xs={12} data-tour-id="cond-mm-comp-type">
					<AlertsComparisonType/>
				</Grid>
				<Grid item xs={12} data-tour-id="cond-mm-same-ins">
					<AlertsSameInsurance/>
				</Grid>
				</Grid>
			</AppFormSection>
			<AppFormSection icon="sliders" title="More features" hint="optional">
				<Grid container spacing={2}>
				<Grid item xs={12} data-tour-id="cond-mm-more">
					<AlertsMoreFeatures/>
				</Grid>
				</Grid>
			</AppFormSection>
		</>}/>
}